import { LocalStorageService } from './local-storage-service';
import { CookieService } from './cookies-service';
let locality;
let currencies;
export var LocalityEnum;
(function (LocalityEnum) {
    LocalityEnum["US"] = "1";
    LocalityEnum["UK"] = "3";
    LocalityEnum["AU"] = "7";
})(LocalityEnum || (LocalityEnum = {}));
export var CurrencySourceEnum;
(function (CurrencySourceEnum) {
    CurrencySourceEnum["URL"] = "Url";
    CurrencySourceEnum["LOCAL_STORAGE"] = "LocalStorage";
    CurrencySourceEnum["COOKIE"] = "Cookie";
    CurrencySourceEnum["SERVER"] = "Server";
})(CurrencySourceEnum || (CurrencySourceEnum = {}));
const CURRENCY_KEY = 'SelectedCurrency';
const LOCALITY_KEY = 'SelectedLocality';
export function toLocalityEnum(localityCode) {
    if (localityCode === 3)
        return LocalityEnum.UK;
    else if (localityCode === 7)
        return LocalityEnum.AU;
    else
        return LocalityEnum.US;
}
function initialize(data) {
    if (!data) {
        return;
    }
    locality = data.locality;
    currencies = data.currencies;
}
function getLocality() {
    return getLocalityFromUrl() || getLocalityFromLocalStorage() || getLocalityFromInitialData();
}
function setLocality(locality) {
    if (!locality) {
        return;
    }
    if (LocalStorageService.isSupported) {
        LocalStorageService.set(LOCALITY_KEY, locality);
    }
    else {
        CookieService.set(LOCALITY_KEY, locality, {
            path: '/'
        });
    }
}
function getLocalityFromInitialData() {
    if (!locality) {
        return null;
    }
    setLocality(locality);
    return getEnumLocalityValue(locality);
}
function getLocalityFromUrl() {
    const urlLocality = getUrlParameter('locality');
    if (!urlLocality) {
        return null;
    }
    return getEnumLocalityValue(urlLocality);
}
function getLocalityFromLocalStorage() {
    if (!LocalStorageService.isSupported) {
        return null;
    }
    const storedLocality = LocalStorageService.get(LOCALITY_KEY);
    if (!storedLocality) {
        return null;
    }
    return getEnumLocalityValue(storedLocality);
}
function getEnumLocalityValue(locality) {
    for (let idx in LocalityEnum) {
        if (LocalityEnum[idx] == locality) {
            return LocalityEnum[idx];
        }
    }
    return null;
}
function getCurrency() {
    return getCurrencyFromUrl() || getCurrencyFromLocalStorage() || getCurrencyFromCookie() || getCurrencyFromInitialData();
}
function setCurrency(currencyCode) {
    if (!currencyCode) {
        return;
    }
    if (LocalStorageService.isSupported) {
        LocalStorageService.set(CURRENCY_KEY, currencyCode);
    }
    else {
        CookieService.set(CURRENCY_KEY, currencyCode, {
            path: '/'
        });
    }
}
function getCurrencyFromUrl() {
    const urlCurrency = getUrlParameter('currency');
    if (!urlCurrency) {
        return null;
    }
    const currencyCode = currencies.find(currency => currency.toLowerCase() === urlCurrency.toLowerCase());
    if (!currencyCode) {
        return null;
    }
    setCurrency(currencyCode);
    return {
        code: currencyCode,
        source: CurrencySourceEnum.URL
    };
}
function getCurrencyFromLocalStorage() {
    if (!LocalStorageService.isSupported) {
        return null;
    }
    const currencyCode = LocalStorageService.get(CURRENCY_KEY);
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum.LOCAL_STORAGE
    };
}
function getCurrencyFromCookie() {
    const currencyCode = CookieService.getJSON(CURRENCY_KEY) || null;
    if (!currencyCode) {
        return null;
    }
    return {
        code: currencyCode,
        source: CurrencySourceEnum.COOKIE
    };
}
function getCurrencyFromInitialData() {
    if (!currencies || !currencies.length) {
        return null;
    }
    const currencyCode = currencies[0];
    setCurrency(currencyCode);
    return {
        code: currencies[0],
        source: CurrencySourceEnum.SERVER
    };
}
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
export const LocalityService = {
    initialize,
    getLocality,
    setLocality,
    getCurrency,
    setCurrency,
    LocalityEnum
};
//# sourceMappingURL=locality-service.js.map